import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from 'redux/actions/app';
import { PERPAGE } from 'config';

const usePagedTable = ({
  fetchList,
  fetchExport,
  deps = [],
  buildParams,
  selectList,
  selectCount,
  perPage = PERPAGE,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLocalLoading] = useState(true);
  const [allLoaded, setAllLoaded] = useState(false);
  const [exportType, setExportType] = useState();
  const [counts, setCounts] = useState();

  const loadItems = (refresh) => {
    setLocalLoading(true);
    const page = refresh ? 1 : Number.parseInt(items.length / perPage + 1, 10);
    const params = buildParams(page, false);
    return fetchList(params)
      .then(res => {
        if (res.code === 200) {
          const list = selectList(res) || [];
          setItems(refresh ? list : [...items, ...list]);
          setAllLoaded(list.length < perPage);
          if (page === 1 && selectCount) setCounts(selectCount(res));
        } else {
          setAllLoaded(true);
        }
        dispatch(setLoading(false));
        setLocalLoading(false);
      })
      .catch(() => {
        setAllLoaded(true);
        dispatch(setLoading(false));
        setLocalLoading(false);
      });
  };

  useEffect(() => {
    setData([]);
    setItems([]);
    setLocalLoading(true);
    setAllLoaded(false);
    loadItems(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  const loadMore = () => {
    if (allLoaded || loading || items.length <= 0) {
      return;
    }
    loadItems();
  };

  const loadExportData = (page, exportMode) => {
    const params = buildParams(page || 1, true);
    dispatch(setLoading(true));
    fetchExport(params).then(res => {
      if (res.code === 200) {
        const list = selectList(res) || [];
        setData(prev => [...prev, ...list]);
        if (list.length < perPage) {
          dispatch(setLoading(false));
          setExportType(exportMode);
        } else {
          loadExportData(page + 1, exportMode);
        }
      }
    });
  };

  return {
    data,
    items,
    counts,
    loading,
    allLoaded,
    exportType,
    setExportType,
    loadMore,
    loadExportData,
    reload: () => loadItems(true),
  };
};

export default usePagedTable;

